import { PropsWithChildren, useState } from 'react';

import { Dropdown as UncontrolledDropdown } from './Dropdown';

type ComponentState = { isOpened: boolean };

type Props = {
    button: (component: ComponentState) => JSX.Element | null | undefined;
    buttonClass?: string;
    className?: string;
    menuItemClassName?: string;
};

const ControlledDropdown = ({ ...props }: PropsWithChildren<Props>): JSX.Element => {
    const [isOpened, setIsOpened] = useState(false);

    const handleMenu = () => setIsOpened(!isOpened);

    return <UncontrolledDropdown {...props} handleMenu={handleMenu} isOpened={isOpened} />;
};

export { ControlledDropdown as Dropdown };
